import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filterStatus: 'ENTER',
  transHead: {
    transId: '',
    Ord_ID: '',
    VanId: '',
    Buyer: '',
    Truck: '',
    status: 'ENTER',
    Slaughterhouse: '',
    CNTRL_PUR: false,
    isEditVan: false
  }
};
const VanReceivingSlice = createSlice({
  name: 'ReceivingSlice',
  initialState: initialState,
  reducers: {
    updateFilterStatus: (state, action) => {
      state.filterStatus = action.payload;
    },
    updateTransHead: (state, action) => {
      state.transHead = action.payload;
    }
  }
});

export const { updateFilterStatus, updateTransHead } = VanReceivingSlice.actions;
export default VanReceivingSlice.reducer;
